export default {"src":"/_next/static/media/icon-tick.75055c61.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};